import tw, { styled } from "twin.macro";

export const Wrapper = styled.nav`
  ${tw`hidden lg:flex justify-end font-bold `}

  ul{
    ${tw`m-0 text-right w-max`}
    padding-left: 1rem;
  }

  ul li {
    ${tw`inline-block relative`}
    margin: 0 10px 0 0;

    a {
      ${tw`flex hover:text-lightorange`}
      padding: 0 0 0 10px;
      transition: all 0.2s ease;
      text-decoration: none;
      color: #000;

      div {
        margin: -4px 0 0 5px;
      }

      &.text-orange{
        ${tw`text-orange hover:text-lightorange`}
      }

      &.active{
        .text{
          text-decoration: underline;
          text-decoration-thickness: 3px;
          text-decoration-color: #F36F34;
        }
      }
    }
  }

  ul li:last-child {
    margin: 0;
  }

  ul li:hover > ul {
    display: block;
  }


  ul ul {
    animation: fadeInMenu 0.3s both ease-in;
    display: none;
    position: absolute;
    left: 0;
    margin: 0;
    top: 18px;
    text-transform: none;
    background: #fff;
    padding: 15px 10px 10px 10px;
    box-shadow: 0px 16px 20px -6px rgb(0 0 0 / 50%);
  }

  ul ul li {
    width: auto;
    min-width: 170px;
    display: block;
  }

  ul ul li a {
    padding: 5px 10px;
    text-decoration: none;
    white-space: nowrap;
  }

  @keyframes fadeInMenu {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;
